module.exports = __webpack_public_path__ + "fonts/sourcesansproblackitalic.a3c012e5.woff";